import { render, staticRenderFns } from "./DocCropEnhanceDetail.vue?vue&type=template&id=67389d8b&scoped=true"
import script from "./DocCropEnhanceDetail.vue?vue&type=script&lang=js"
export * from "./DocCropEnhanceDetail.vue?vue&type=script&lang=js"
import style0 from "./DocCropEnhanceDetail.vue?vue&type=style&index=0&id=67389d8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67389d8b",
  null
  
)

export default component.exports